
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface InsightsCTAProps {
  countryName: string;
}

const InsightsCTA = ({ countryName }: InsightsCTAProps) => {
  const navigate = useNavigate();
  
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/', { state: { noRedirect: true } });
    
    // Give the page time to load before scrolling
    setTimeout(() => {
      const element = document.querySelector('#register');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };
  
  return (
    <section className="py-10 bg-card border-t border-border">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-2xl font-bold text-foreground mb-4">Help Shape {countryName}'s Future</h2>
        <p className="text-muted-foreground max-w-2xl mx-auto mb-6">
          Join our network of verified pollsters and contribute to data-driven insights for {countryName}.
        </p>
        <Button asChild variant="purple" className="bg-nation-purple hover:bg-nation-purple-dark text-white">
          <a href="/#register" onClick={handleClick}>Become a Verified Pollster</a>
        </Button>
      </div>
    </section>
  );
};

export default InsightsCTA;
